<template>
  <div class="title-bar">
    <ContextMenu
      id="training-mobile-menu"
      :items="menu"
      class="d-sm-none float-right"
      align="right"
    />
    <h1>{{ title }}</h1>
    <TabMenu :tabs="menu" :current="current" class="d-none d-sm-block pt-2" />
  </div>
</template>

<script>

export default {
  props: {
    title: { type: String, required: true },
    current: { type: String, default: "" },
  },
  computed: {
    menu() {
      let menu = [];
      menu.push({
        label: "History",
        action: () => {
          this.goToRoute("training.history.index", { type: "online" });
        },
      });
      if (this.$root.isAdminager) {
        menu.push({
          label: "Users",
          action: () => {
            this.goToRoute("training.users.index");
          },
        });
        menu.push({
          label: "Companies",
          action: () => {
            this.goToRoute("training.companies.index");
          },
        });
      } else {
        menu.push({
          label: "Company Directory",
          action: () => {
            this.goToRoute("training.users.index");
          },
        });
      }
      return menu;
    },
  },
};
</script>